import { U2000ApiValueToDisplayYmd } from "../../u2000Core/tools/U2000DateTimeHelpers";

/**
 * Affichage lecture seule d'une date de ligne feuille (API `yyyy-MM-dd` ou instant ISO).
 * Jour civil affiché tel quel ; instant ISO → jour civil dans le fuseau d'affichage org.
 */
export function u3130FormatLineDateDisplay(raw: string | undefined | null, language: string): string {
  void language;
  const ymd = U2000ApiValueToDisplayYmd(raw);
  return ymd ?? "—";
}
